import { Component, OnInit } from '@angular/core';
import { AuthStatusService } from 'src/app/services/auth-status.service';

@Component({
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent implements OnInit {

  groups: any;

  constructor(
    private authStatusService: AuthStatusService
  ) { 
    try {
      this.groups = this.authStatusService.getRoles().map((elem: string) => elem.toLowerCase());
    }
    catch {
      this.groups = [];
    }
  }

  ngOnInit(): void {
  }

}
